export default __webpack_public_path__ + "static/media/logo.3fcb1ae8.png";